/* eslint-disable import/no-duplicates */
import {
  MODIFY_FILTERS,
  FETCH_SEARCH_RESULTS,
  RECEIVE_SEARCH_RESULTS,
  SEARCH_RESULTS_IS_LOADING,
  FETCH_PRESET_FILTERS_IS_LOADING,
  FETCH_COLUMN_PRESETS_IS_LOADING,
  SAVE_PRESET_FILTERS_IS_LOADING,
  UPDATE_PRESET_FILTERS_IS_LOADING,
  DELETE_PRESET_FILTERS_IS_LOADING,
  PRESET_FILTERS_FETCH_DATA_SUCCESS,
  SEARCH_RESULTS_HAS_ERRORED,
  SEARCH_RESULTS_FETCH_DATA_SUCCESS,
  COLUMN_PRESET_FETCH_DATA_SUCCESS,
  PRESET_FILTERS_FETCH_HAS_ERRORED,
  TOTAL_EVENTS_FETCH_SUCCESS,
  CURRENT_PAGE_FETCH_SUCCESS,
  PRESET_FILTER_SAVE_SUCCESS,
  HANDLE_LOAD_FILTERS,
  HANDLE_SAVE_FILTERS,
  HANDLE_LOAD_COLUMN_PRESETS,
  HANDLE_SAVE_COLUMN_PRESETS,
  HANDLE_DELETE_COLUMN_PRESETS,
  SHOW_PRESET_FILTER_OP_BUTTON,
  SHOW_COLUMN_PRESET_OP_BUTTON,
  HANDLE_PRESET_FILTER_OP_SELECT_CHANGE,
  HANDLE_COLUMN_PRESET_OP_SELECT_CHANGE,
  PRESET_FILTER_UPDATE_BUTTON_ENABLED,
  PRESET_FILTER_DELETE_BUTTON_ENABLED,
  COLUMN_PRESET_LOAD_BUTTON_ENABLED,
  COLUMN_PRESET_DEFAULT_BUTTON_ENABLED,
  COLUMN_PRESET_SAVE_BUTTON_ENABLED,
  PRESET_FILTER_LOAD_BUTTON_ENABLED,
  PRESET_FILTER_OP_MODAL_LOADING,
  TRIGGER_UPDATE_FORM_VALUES,
  PRESET_FILTER_UPDATE_SUCCESS,
  PRESET_FILTER_DELETE_SUCCESS,
  SNACKBAR_IS_OPEN,
  SET_SNACKBAR_MESSAGE,
  CHANGE_CURRENT_PAGE,
  RELOAD_ALL_FILTERS,
  RELOAD_ALL_COLUMN_PRESETS,
  COLUMN_NAMES_CHANGE,
  SET_COLUMN_PRESET_NAME,
  COLUMN_PRESET_SAVE_IS_LOADING,
  COLUMN_PRESET_LOAD_BUTTON_VISIBLE,
  COLUMN_PRESET_SAVE_BUTTON_VISIBLE,
  COLUMN_PRESET_LOAD_MODAL_LOADING,
  PULL_NOW_POST_IN_PROGRESS,
  HANDLE_SELECTION_CHANGE,
  INVENTORY_TAG_FETCH_SUCCESS,
  SUB_GENRE_UPDATE_SUCCESS,
  HANDLE_EDIT_NOTIFICATIONS,
  HANDLE_TOGGLE_FILTERS,
  NOTIFICATION_SWITCH_ACTIVE,
  COLUMN_ORDER_CHANGE,
  FETCH_NOTIFICATIONS_NAV_BAR_SUCCESS,
  COLUMN_WIDTH_CHANGE,
  COLUMN_PINNED_CHANGE,
  LIMITSHEET_SUCCESS_OPEN,
  LIMITSHEET_URL,
  WHOS_NAME_CHANGE,
  LIMITSHEET_TITLE,
  INFO_SNACKBAR_OPEN,
  EVENT_SEARCH_ROW_SELECTED,
  SHOW_SAVE_FILTERS_BUTTON,
  SHOW_SAVE_COLUMNS_BUTTON,
  EVENT_TAGS_FETCH_SUCCESS,
} from '../constants/event-search';

import { columnWidths as gridColumnWidths } from '../constants/grid-properties';

const initialState = {
  filters: [],
  searchResults: [],
  isLoading: false,
  columnPresetName: '',
  currentPage: 0,
  totalEvents: 0,
  presetFilterLoadModalOpen: false,
  presetFilterSaveModalOpen: false,
  columnPresetLoadModalOpen: false,
  columnPresetSaveModalOpen: false,
  columnPresetLoadModalLoading: false,
  presetFilters: [],
  presetFilterLoadButtonVisible: false,
  presetFilterSaveButtonVisible: false,
  columnPresetLoadButtonVisible: false,
  columnPresetSaveButtonVisible: false,
  showSaveColumnsButton: false,
  selectedPreset: -1,
  selectedColumnPreset: -1,
  presetFilterUpdateButtonEnabled: false,
  presetFilterDeleteButtonEnabled: false,
  presetFilterLoadButtonEnabled: false,
  columnPresetLoadButtonEnabled: false,
  columnPresetSaveButtonEnabled: false,
  columnPresetDefaultButtonEnabled: false,
  notificationPresetSaveModalOpen: false,
  updateFormValues: false,
  snackbarIsOpen: false,
  snackbarMessage: '',
  reloadAllFilters: false,
  columnPresets: [],
  savedColumnPresets: [],
  pullNowPostInProgress: false,
  selection: [],
  selectedEvents: [],
  numSelectedEvents: 0,
  inventoryTags: [],
  eventTags: [],
  subGenres: [],
  leftColumns: [],
  filtersOpen: false,
  invTagsChecked: false,
  notificationSwitchActive: true,
  columnWidths: gridColumnWidths,
  openSuccessSnackBar: false,
  sheetUrl: '',
  whosNames: ['REPS'],
  sheetName: '',
  snackbarOpen: false,
  columnOrder: [
    'event_id',
    'emoji',
    'event_name',
    'event_genre',
    'performer',
    'event_links',
    'event_date',
    'day_of_week',
    'days_until_event',
    'onsale_date',
    'checked_time',
    'days_since_last_checked',
    'venue_name',
    'venue_city',
    'venue_state',
    'venue_type',
    'venue_capacity',
    'primary_event_capacity',
    'primary_qnt_3day',
    'primary_qnt_7day',
    'primary_qnt_30day',
    'one_day_primary_pace',
    'three_day_primary_pace',
    'seven_day_primary_pace',
    'thirty_day_primary_pace',
    'primary_tix_av',
    'primary_percent_av',
    'primary_tickets_cost',
    'cloakedness',
    'secondary_tix_av',
    'primary_min_price_face',
    'primary_min_price_total',
    'sh_min_price',
    'sh_tickets_av',
    'sh_total_sales',
    'sh_sales_24hr',
    'sh_sales_3ma',
    'sh_sales_7ma',
    'sh_1_day_min_price_ma',
    'sh_3_day_min_price_ma',
    'sh_7_day_min_price_ma',
    'sh_30_day_min_price_ma',
    'sh_3ma',
    'sh_7ma',
    'sh_num_viewing',
    'sb_total_num_purchased',
    'sb_total_num_held',
    'sb_total_num_sold',
    'sb_today_num_sold',
    'sb_seven_day_num_sold',
    'sb_thirty_day_num_sold',
    'days_since_last_sale',
    'days_since_last_purchase',
    'sb_last_invoice_date',
    'sb_one_day_pace',
    'sb_three_day_pace',
    'sb_pace',
    'sb_thirty_day_pace',
    'sb_total_margin',
    'sb_today_margin',
    'sb_seven_day_margin',
    'sb_thirty_day_margin',
    'total_cost_of_tickets_held',
    'tickets_needed_to_sell_per_hour',
    'tickets_needed_to_sell_per_day',
    'inventory_tags',
    'event_tags',
    'hedge_fund_name',
    'mrclean_links',
  ],
  selectedRows: [],
};

const eventSearch = (state = initialState, action) => {
  switch (action.type) {
    case MODIFY_FILTERS:
      return { ...state, filters: [...state.filters, action.payload] };
    case RECEIVE_SEARCH_RESULTS:
      return { ...state, searchResults: [...state.searchResults, action.payload] };
    case FETCH_SEARCH_RESULTS:
      return action;
    case SEARCH_RESULTS_IS_LOADING:
      return { ...state, isLoading: action.isLoading };
    case FETCH_PRESET_FILTERS_IS_LOADING:
    case FETCH_COLUMN_PRESETS_IS_LOADING:
    case SAVE_PRESET_FILTERS_IS_LOADING:
    case UPDATE_PRESET_FILTERS_IS_LOADING:
    case DELETE_PRESET_FILTERS_IS_LOADING:
    case COLUMN_PRESET_SAVE_IS_LOADING:
      return state;
    case SEARCH_RESULTS_HAS_ERRORED:
      return state;
    case SEARCH_RESULTS_FETCH_DATA_SUCCESS:
      return { ...state, searchResults: action.searchResults, selectedEvents: [], numSelectedEvents: 0 };
    case COLUMN_PRESET_FETCH_DATA_SUCCESS:
      return { ...state, savedColumnPresets: action.savedColumnPresets };
    case INVENTORY_TAG_FETCH_SUCCESS:
      return { ...state, inventoryTags: action.inventoryTags };
    case PRESET_FILTERS_FETCH_DATA_SUCCESS:
      return { ...state, presetFilters: action.presetFilters };
    case PRESET_FILTER_SAVE_SUCCESS:
      return state;
    case PRESET_FILTERS_FETCH_HAS_ERRORED:
      return state;
    case TOTAL_EVENTS_FETCH_SUCCESS:
      return { ...state, totalEvents: action.totalEvents };
    case SUB_GENRE_UPDATE_SUCCESS:
      return { ...state, subGenres: action.subGenres };
    case CURRENT_PAGE_FETCH_SUCCESS:
      return { ...state, currentPage: action.currentPage };
    case HANDLE_LOAD_FILTERS:
      return { ...state, presetFilterLoadModalOpen: action.presetFilterLoadModalOpen };
    case HANDLE_EDIT_NOTIFICATIONS:
      return { ...state, notificationPresetSaveModalOpen: action.notificationPresetSaveModalOpen };
    case HANDLE_SAVE_FILTERS:
      return { ...state, presetFilterSaveModalOpen: action.presetFilterSaveModalOpen };
    case SHOW_PRESET_FILTER_OP_BUTTON:
      return { ...state, presetFilterLoadButtonVisible: action.presetFilterLoadButtonVisible };
    case SHOW_COLUMN_PRESET_OP_BUTTON:
      return { ...state, columnPresetLoadButtonVisible: action.columnPresetLoadButtonVisible };
    case HANDLE_PRESET_FILTER_OP_SELECT_CHANGE:
      return { ...state, selectedPreset: action.selectedPreset };
    case HANDLE_COLUMN_PRESET_OP_SELECT_CHANGE:
      return { ...state, selectedColumnPreset: action.selectedColumnPreset };
    case PRESET_FILTER_UPDATE_BUTTON_ENABLED:
      return { ...state, presetFilterUpdateButtonEnabled: action.presetFilterUpdateButtonEnabled };
    case PRESET_FILTER_DELETE_BUTTON_ENABLED:
      return { ...state, presetFilterDeleteButtonEnabled: action.presetFilterDeleteButtonEnabled };
    case PRESET_FILTER_LOAD_BUTTON_ENABLED:
      return { ...state, presetFilterLoadButtonEnabled: action.presetFilterLoadButtonEnabled };
    case COLUMN_PRESET_LOAD_BUTTON_ENABLED:
      return { ...state, columnPresetLoadButtonEnabled: action.columnPresetLoadButtonEnabled };
    case COLUMN_PRESET_DEFAULT_BUTTON_ENABLED:
      return { ...state, columnPresetDefaultButtonEnabled: action.columnPresetDefaultButtonEnabled };
    case COLUMN_PRESET_SAVE_BUTTON_ENABLED:
      return { ...state, columnPresetSaveButtonEnabled: action.columnPresetSaveButtonEnabled };
    case PRESET_FILTER_OP_MODAL_LOADING:
      return { ...state, presetFilterOpModalLoading: action.presetFilterOpModalLoading };
    case TRIGGER_UPDATE_FORM_VALUES:
      return { ...state, updateFormValues: action.updateFormValues };
    case PRESET_FILTER_UPDATE_SUCCESS:
      return { ...state, presetFilterUpdateSuccess: action.presetFilterUpdateSuccess };
    case PRESET_FILTER_DELETE_SUCCESS:
      return { ...state, presetFilterDeleteSuccess: action.presetFilterDeleteSuccess };
    case SNACKBAR_IS_OPEN:
      return { ...state, snackbarIsOpen: action.snackbarIsOpen };
    case SET_SNACKBAR_MESSAGE:
      return { ...state, snackbarMessage: action.snackbarMessage };
    case CHANGE_CURRENT_PAGE:
      return { ...state, currentPage: action.currentPage };
    case RELOAD_ALL_FILTERS:
      return { ...state, reloadAllFilters: action.reloadAllFilters };
    case RELOAD_ALL_COLUMN_PRESETS:
      return { ...state, reloadAllColumnPresets: action.reloadAllColumnPresets };
    case HANDLE_LOAD_COLUMN_PRESETS:
      return { ...state, columnPresetLoadModalOpen: action.columnPresetLoadModalOpen };
    case HANDLE_SAVE_COLUMN_PRESETS:
      return { ...state, columnPresetSaveModalOpen: action.columnPresetSaveModalOpen };
    case HANDLE_DELETE_COLUMN_PRESETS:
      return { ...state, columnPresetDeleteModalOpen: action.columnPresetDeleteModalOpen };
    case COLUMN_NAMES_CHANGE:
      return { ...state, columnPresets: action.columnPresets };
    case SET_COLUMN_PRESET_NAME:
      return { ...state, columnPresetName: action.columnPresetName };
    case COLUMN_PRESET_LOAD_BUTTON_VISIBLE:
      return { ...state, columnPresetLoadButtonVisible: action.columnPresetLoadButtonVisible };
    case COLUMN_PRESET_SAVE_BUTTON_VISIBLE:
      return { ...state, columnPresetSaveButtonVisible: action.columnPresetSaveButtonVisible };
    case COLUMN_PRESET_LOAD_MODAL_LOADING:
      return { ...state, columnPresetLoadModalLoading: action.columnPresetLoadModalLoading };
    case PULL_NOW_POST_IN_PROGRESS:
      return { ...state, pullNowPostInProgress: action.pullNowPostInProgress };
    case HANDLE_SELECTION_CHANGE:
      return { ...state, selectedEvents: action.selectedEvents, numSelectedEvents: action.numSelectedEvents };
    case HANDLE_TOGGLE_FILTERS:
      return { ...state, filtersOpen: action.filtersOpen };
    case COLUMN_ORDER_CHANGE:
      return { ...state, columnOrder: action.columnOrder };
    case NOTIFICATION_SWITCH_ACTIVE:
      return { ...state, notificationSwitchActive: action.notificationSwitchActive };
    case FETCH_NOTIFICATIONS_NAV_BAR_SUCCESS:
      return { ...state, notificationsCount: action.notificationsCount };
    case COLUMN_WIDTH_CHANGE:
      return { ...state, columnWidths: action.columnWidths };
    case COLUMN_PINNED_CHANGE:
      return { ...state, leftColumns: action.leftColumns };
    case LIMITSHEET_SUCCESS_OPEN:
      return { ...state, openSuccessSnackBar: action.openSuccessSnackBar };
    case LIMITSHEET_URL:
      return { ...state, sheetUrl: action.sheetUrl };
    case LIMITSHEET_TITLE:
      return { ...state, sheetName: action.sheetName };
    case WHOS_NAME_CHANGE:
      return { ...state, whosNames: action.whosNames };
    case INFO_SNACKBAR_OPEN:
      return { ...state, snackbarOpen: action.snackbarOpen };
    case EVENT_SEARCH_ROW_SELECTED:
      return { ...state, selectedRows: action.payload };
    case SHOW_SAVE_FILTERS_BUTTON:
      return { ...state, presetFilterSaveButtonVisible: action.presetFilterSaveButtonVisible };
    case SHOW_SAVE_COLUMNS_BUTTON:
      return { ...state, showSaveColumnsButton: action.showSaveColumnsButton };
    case EVENT_TAGS_FETCH_SUCCESS:
      return { ...state, eventTags: action.eventTags };
    default:
      return state;
  }
};

export default eventSearch;
